const MINOR_UNITS_PER_MAJOR = 100

/** Formats a minor-unit amount as currency, dropping decimals on whole amounts; `locale` is required, so call through `useFormatters().formatPrice()`. */
export function formatPrice(minorUnits: number, currency: string, locale: string): string {
  const major = minorUnits / MINOR_UNITS_PER_MAJOR
  const fractionDigits = Number.isInteger(major) ? 0 : 2
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(major)
}
